import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable react/jsx-no-target-blank */
import * as React from 'react';
export var OptionalAnchor = /*#__PURE__*/React.forwardRef(function OptionalAnchor(props, ref) {
  if (props.href) {
    return /*#__PURE__*/React.createElement("a", _extends({
      rel: "noopener"
    }, props, {
      ref: ref
    }));
  }
  return /*#__PURE__*/React.createElement("span", _extends({}, props, {
    ref: ref
  }));
});